import { deleteTildes } from "./deleteTildes"
import listTypeDoc from "./typeDoc.json"
export const generateOptionsDoc = (list, setState) => {
  const contentOption = list.map((element) => deleteTildes(element))
  const fixedList = listTypeDoc.map((element) => {
    element.name = deleteTildes(element.name)
    return element
  })

  const auxListOption = []
  for (let i = 0; i < list.length; i++) {
    auxListOption.push(
      listTypeDoc[
        fixedList.findIndex(
          (item) => item.name.toLowerCase() === contentOption[i].toLowerCase(),
        )
      ],
    )
  }
  setState(auxListOption)
}
